import React from 'react'
import { useTheme } from 'styled-components'
import { LogoProps } from './types'

// Meditopia logo (2025 rebrand).
// Light theme -> full-colour logo, dark theme -> white logo.
// styled-components theme `mode` ('light' | 'dark') drives the swap.
const Logo: React.FC<LogoProps> = ({ size = 40, className }) => {
  const theme = useTheme() as { mode?: 'light' | 'dark' }
  const src =
    theme?.mode === 'dark'
      ? '/meditopia-logo-dark.svg'
      : '/meditopia-logo-light.svg'
  const width = Math.round((118 * size) / 30)
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      width={width}
      height={size}
      alt="Meditopia"
      className={className}
    />
  )
}

export default Logo
